import { apiService } from '.';
import {
    AssistantRule,
    AssistantRuleCategory,
} from '../shared/types/assistant-rule';

export const asyncGetAssistantRules = async (): Promise<
    Record<string, AssistantRule[]>
> => {
    try {
        const { items } = await apiService.get<Record<string, AssistantRule[]>>(
            '/api/assistant-rule/grouped-rules'
        );
        return (items as any) || {};
    } catch (error) {
        return {};
    }
};

export const asyncGetAssistantRule = async (
    id: string
): Promise<AssistantRule | undefined> => {
    try {
        const { items: data }: { items: AssistantRule } = await apiService.get(
            `/api/assistant-rule/${id}`
        );
        return data;
    } catch (error) {}
};

export const asyncCreateAssistantRule = async (
    info: AssistantRule
): Promise<AssistantRule | undefined> => {
    try {
        const { items: data }: { items: AssistantRule } = await apiService.post(
            '/api/assistant-rule',
            info
        );
        return data;
    } catch (error) {}
};

export const asyncUpdateAssistantRule = async (
    id: string,
    info: AssistantRule
): Promise<AssistantRule | undefined> => {
    try {
        const { items: data }: { items: AssistantRule } =
            await apiService.patch(`/api/assistant-rule/${id}`, info);
        return data;
    } catch (error) {}
};

export const asyncDeleteAssistantRule = async (id: string | number) => {
    return await apiService.delete(`/api/assistant-rule/${id}`);
};

export const asyncGetAssistantRuleCategories = async (): Promise<
    AssistantRuleCategory[]
> => {
    try {
        const { items: data }: { items: AssistantRuleCategory[] } =
            await apiService.get('/api/assistant-rule-category');
        return data || [];
    } catch (error) {
        return [];
    }
};

export const asyncGetAssistantRuleCategory = async (
    id: string
): Promise<AssistantRuleCategory | undefined> => {
    try {
        const { items: data }: { items: AssistantRuleCategory } =
            await apiService.get(`/api/assistant-rule-category/${id}`);
        return data;
    } catch (error) {}
};

export const asyncCreateAssistantRuleCategory = async (
    info: AssistantRuleCategory
): Promise<AssistantRuleCategory | undefined> => {
    try {
        const { items: data }: { items: AssistantRuleCategory } =
            await apiService.post('/api/assistant-rule-category', info);
        return data;
    } catch (error) {}
};

export const asyncUpdateAssistantRuleCategory = async (
    id: string,
    info: AssistantRuleCategory
): Promise<AssistantRuleCategory | undefined> => {
    try {
        const { items: data }: { items: AssistantRuleCategory } =
            await apiService.patch(`/api/assistant-rule-category/${id}`, info);
        return data;
    } catch (error) {}
};

export const asyncDeleteAssistantRuleCategory = async (id: string | number) => {
    return await apiService.delete(`/api/assistant-rule-category/${id}`);
};
